import React from 'react';
import styled from 'styled-components';
import { Translation, useTranslation } from '~/components/Translation';
import {
	CTARow,
	ImageBlock,
	Image640x560,
	MultipleSrcPicture,
	Signup,
	Header,
} from '~/components/Marketing';
import LinkBody from '~/components/LinkBodyV2';
import helpLinks from '~/constants/helpLinks';
import featureFlags from '~/constants/featureFlags';
import analytics from '~/services/analytics';
import usePageTrack from '~/services/analytics/usePageTrack';
import { media, visibility } from '~/styles/mixins';

import HeroLargePng from './hero_image_large.png';
import HeroLargeWebp from './hero_image_large.webp';
import HeroSmallPng from './hero_image_small.png';
import HeroSmallWebp from './hero_image_small.webp';

import BlockImageShowCommentsPng from './block_image_show_comments.png';
import BlockImageShowCommentsWebp from './block_image_show_comments.webp';
import BlockImageGuestInterviewsPng from './block_image_guest_interviews.png';
import BlockImageGuestInterviewsWebp from './block_image_guest_interviews.webp';
import BlockImageGiveAwaysPng from './block_image_giveaways.png';
import BlockImageGiveAwaysWebp from './block_image_giveaways.webp';
import MobileLandingSignup from '../../../Signup/scenes/MobileLandingSignup';

const HeroLarge = styled.div`
	width: 100%;
	max-width: 1200px;
	margin: 64px auto 24px auto;
	${visibility.showMedium}
`;

const HeroLargeImage = styled(MultipleSrcPicture)`
	width: 100%;
`;

const HeroSmall = styled.div`
	width: 100%;
	max-width: 500px;
	margin: 16px auto;
	padding: 0 24px;
	${media.medium`
    padding: 0 80px;
  `}
	${visibility.hideMedium}
`;

const HeroSmallImage = styled(MultipleSrcPicture)`
	width: 100%;
`;

const Image752x560 = styled(MultipleSrcPicture)`
	width: 100%;
	display: block;
	max-width: 752px;
	height: auto;
`;

const AudienceEngagement = () => {
	usePageTrack({
		name: analytics.events.AUDIENCE_ENGAGEMENT,
		category: analytics.events.category.MARKETING,
	});

	return (
		<main role="main">
			<Header
				title={<Translation tid="landingAudienceEngagement.title" />}
				subtitles={[
					<Translation key="1" tid="landingAudienceEngagement.subtitle" />,
				]}
				cta={<Signup />}
				redesign={featureFlags.orion.landingPageRedesignV2}
			/>
			<HeroLarge>
				<HeroLargeImage
					webpSrc={HeroLargeWebp}
					fallbackSrc={HeroLargePng}
					alt=""
				/>
			</HeroLarge>
			<HeroSmall>
				<HeroSmallImage
					webpSrc={HeroSmallWebp}
					fallbackSrc={HeroSmallPng}
					alt=""
				/>
			</HeroSmall>
			<MobileLandingSignup />
			<ImageBlock
				body={useTranslation(
					'landingAudienceEngagement.block.audienceComments.body',
				)}
				header={useTranslation(
					'landingAudienceEngagement.block.audienceComments.header',
				)}
				image={
					<Image640x560
						webpSrc={BlockImageShowCommentsWebp}
						fallbackSrc={BlockImageShowCommentsPng}
						alt=""
					/>
				}
			/>
			<ImageBlock
				body={useTranslation(
					'landingAudienceEngagement.block.guestInterviews.body',
				)}
				color="slate"
				header={useTranslation(
					'landingAudienceEngagement.block.guestInterviews.header',
				)}
				image={
					<Image640x560
						webpSrc={BlockImageGuestInterviewsWebp}
						fallbackSrc={BlockImageGuestInterviewsPng}
						alt=""
					/>
				}
				reverse={true}
			/>
			<ImageBlock
				header={useTranslation(
					'landingAudienceEngagement.block.giveAway.header',
				)}
				body={
					<Translation
						components={{
							link: (
								<LinkBody
									href={helpLinks.giveawayTool}
									newTab
									underline={false}
								/>
							),
						}}
						tid="landingAudienceEngagement.block.giveAway.body.one"
					/>
				}
				bodyTwo={useTranslation(
					'landingAudienceEngagement.block.giveAway.body.two',
				)}
				image={
					<Image752x560
						webpSrc={BlockImageGiveAwaysWebp}
						fallbackSrc={BlockImageGiveAwaysPng}
						alt=""
					/>
				}
			/>
			<CTARow
				cta={<Signup />}
				subtitle={<Translation tid="landingAudienceEngagement.cta.subtitle" />}
				title={<Translation tid="landingAudienceEngagement.cta.title" />}
			/>
		</main>
	);
};

export default AudienceEngagement;
